/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import AddIcon from '@mui/icons-material/Add';
import BorderAllIcon from '@mui/icons-material/BorderAll';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, IconButton, Typography } from '@mui/material';
import React from 'react';
import { buildAlertTab, buildEventTab, buildGeneralTab, buildHiddenTab, buildModalTab, buildStyleTab, buildValidateTab, showWidgetEditDialog, } from '../WidgetEditDialog';
import { callConfigFunction, defaultWidgetLabelProvider, getLabelAndValuePairsFromChildDynamicRows, handleWidgetOnLoad, handleWidgetUpdate, isSkipValidate, joinLabels, makeNewConfigUnique, renderForm, setModalChildSkipValidate, } from '../WidgetForm/Utils';
import { TemplateOutput } from '../WidgetFormContent/Components';
import { EditModeDialog, ModalDialogForm, Panel } from '../WidgetFormModalPanel/Components';
import { BaseLayoutColumn } from '../WidgetFormPanel/Components';
import { WidgetHandler } from '../WidgetHandler';
import { type } from './types';
const WidgetFormModalPanelList = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const childDynamicRows = (_a = props.childDynamicRows) !== null && _a !== void 0 ? _a : [];
    const currentLength = childDynamicRows.length;
    const maxLength = (_b = props.config.validate) === null || _b === void 0 ? void 0 : _b.maxLength;
    const allowAdd = maxLength == null || currentLength < maxLength;
    const error = props.editMode ? undefined : ((_c = props.internalData.error) !== null && _c !== void 0 ? _c : props.error);
    const getModalChildProps = (index) => {
        const row = index === -1 ? childDynamicRows[childDynamicRows.length - 1] : childDynamicRows[index];
        if (props.config.panel.children) {
            return row.childProps.slice(props.config.panel.children.length);
        }
        else {
            return row.childProps;
        }
    };
    const getRowChildProps = (index) => {
        const row = index === -1 ? childDynamicRows[childDynamicRows.length - 1] : childDynamicRows[index];
        if (props.config.panel.children) {
            return row.childProps.slice(0, props.config.panel.children.length);
        }
        else {
            return [];
        }
    };
    const showModal = (index) => {
        if (index === -1) {
            props.internalData.modalState = { open: true, index, data: {} };
        }
        else {
            const data = props.getDataArray()[index];
            props.internalData.modalState = { open: true, index, data: data != null ? JSON.parse(JSON.stringify(data)) : {} };
        }
        props.update();
        renderForm(props);
    };
    const onSave = (data) => {
        const index = props.internalData.modalState.index;
        if (index === -1) {
            props.insertDataRow(-1);
            const insertedRowChildProps = childDynamicRows[childDynamicRows.length - 1].childProps;
            if (props.config.panel.children) {
                setModalChildSkipValidate(insertedRowChildProps.slice(props.config.panel.children.length));
            }
            else {
                setModalChildSkipValidate(insertedRowChildProps);
            }
            const array = props.getDataArray();
            array[array.length - 1] = data;
            props.setData(array);
        }
        else {
            const array = props.getDataArray();
            array[index] = data;
            props.setData(array);
        }
        props.internalData.modalState.open = false;
        renderForm(props, { changed: true, autoSaveImmediately: props.config.autoSave });
    };
    const onCancel = () => {
        props.internalData.modalState.open = false;
        props.update();
        renderForm(props);
    };
    const onCloseAfterTransition = () => {
        delete props.internalData.modalState;
        props.update();
        renderForm(props);
    };
    const deleteRow = (index) => {
        props.internalData.deleteRowIndex = index;
        props.update();
        renderForm(props);
    };
    const onCancelDelete = () => {
        delete props.internalData.deleteRowIndex;
        props.update();
        renderForm(props);
    };
    const onConfirmDelete = () => {
        const index = props.internalData.deleteRowIndex;
        delete props.internalData.deleteRowIndex;
        props.deleteDataRow(index);
        if (props.internalData.expandedRows) {
            props.internalData.expandedRows.splice(index, 1);
        }
        renderForm(props, { changed: true, autoSaveImmediately: props.config.autoSave });
    };
    return (React.createElement(Box, null,
        props.editMode && (React.createElement(EditModeDialog, { config: props.config },
            React.createElement(BaseLayoutColumn, { spacing: 16, childrenEditorPath: 'modal.children', childProps: getModalChildProps(0), renderData: props.renderData, editMode: props.editMode, dragTargetPlaceholderMessage: 'Drop here' }))),
        !props.editMode && ((_d = props.internalData.modalState) === null || _d === void 0 ? void 0 : _d.index) === -1 && (React.createElement(ModalDialogForm, { open: props.internalData.modalState.open, data: props.internalData.modalState.data, parentModalWidgetHandler: new WidgetHandler(props), formParams: props.rootParams.formParams, valueProviders: props.rootParams.valueProviders, subFormProviders: props.rootParams.subFormProviders, globalWidgetConfig: props.rootParams.globalWidgetConfig, rules: props.rootParams.rules, widgets: props.widgets, onSave: onSave, onCancel: onCancel, onCloseAfterTransition: onCloseAfterTransition, config: props.config })),
        childDynamicRows.map((row, index) => {
            var _a, _b, _c;
            const label = props.config.label + (childDynamicRows.length > 1 ? ' ' + (index + 1) : '');
            let alert = props.config.panel.alert;
            if (alert === null || alert === void 0 ? void 0 : alert.custom) {
                const handler = new WidgetHandler(props, row);
                const data = handler.getData();
                alert = callConfigFunction((_a = props.config.panel.alert) === null || _a === void 0 ? void 0 : _a.custom, 'panel alert custom', 'value, handler', data, handler);
            }
            return (React.createElement(React.Fragment, { key: row.id },
                ((_b = props.internalData.modalState) === null || _b === void 0 ? void 0 : _b.index) === index && (React.createElement(ModalDialogForm, { open: props.internalData.modalState.open, data: props.internalData.modalState.data, parentModalWidgetHandler: new WidgetHandler(props, row), formParams: props.rootParams.formParams, valueProviders: props.rootParams.valueProviders, subFormProviders: props.rootParams.subFormProviders, globalWidgetConfig: props.rootParams.globalWidgetConfig, rules: props.rootParams.rules, widgets: props.widgets, onSave: onSave, onCancel: onCancel, onCloseAfterTransition: onCloseAfterTransition, config: props.config })),
                React.createElement(Panel, { variant: (_c = props.config.style) === null || _c === void 0 ? void 0 : _c.variant, label: label, alert: alert, actions: React.createElement(Box, null,
                        React.createElement(IconButton, { color: 'primary', sx: { alignSelf: { xs: 'flex-end', sm: 'center' } }, onClick: () => showModal(index), "aria-label": 'Edit ' + label, tabIndex: props.editMode ? -1 : undefined, "data-test": 'edit-button' },
                            React.createElement(DriveFileRenameOutlineIcon, null)),
                        React.createElement(IconButton, { color: 'primary', sx: { alignSelf: { xs: 'flex-end', sm: 'center' } }, onClick: () => deleteRow(index), "aria-label": 'Delete ' + label, tabIndex: props.editMode ? -1 : undefined, "data-test": 'delete-button' },
                            React.createElement(DeleteOutlineIcon, null)),
                        React.createElement(Dialog, { open: props.internalData.deleteRowIndex === index, onClose: (event, reason) => {
                                if (reason === 'escapeKeyDown') {
                                    onCancelDelete();
                                }
                            } },
                            React.createElement(DialogTitle, null, "Are you sure you want to delete this row?"),
                            React.createElement(DialogContent, null,
                                React.createElement(Typography, null, "By deleting, you will remove all the information you\u2019ve entered.")),
                            React.createElement(DialogActions, null,
                                React.createElement(Button, { color: 'primary', onClick: onCancelDelete, "data-test": 'cancel-button' }, "Cancel"),
                                React.createElement(Button, { color: 'primary', onClick: onConfirmDelete, "data-test": 'delete-button' }, "Delete")))) },
                    props.config.panel.template && (React.createElement(Typography, { component: 'div', "data-test": 'template' },
                        React.createElement(TemplateOutput, { template: props.config.panel.template, props: props, row: row }))),
                    props.config.panel.render && props.config.panel.render(new WidgetHandler(props, row)),
                    props.config.panel.children && (React.createElement(Box, { pt: 2 },
                        React.createElement(BaseLayoutColumn, { spacing: 16, childrenEditorPath: 'panel.children', childProps: getRowChildProps(index), renderData: props.renderData, editMode: props.editMode }))))));
        }),
        allowAdd && (!((_e = props.config.style) === null || _e === void 0 ? void 0 : _e.variant) || props.config.style.variant === 'level1') && (React.createElement(Box, null,
            React.createElement(Button, { startIcon: React.createElement(AddIcon, null), variant: 'text', onClick: () => showModal(-1), tabIndex: props.editMode ? -1 : undefined, "data-test": 'add-button', autoFocus: (_f = (!props.editMode && props.config.autoFocus)) !== null && _f !== void 0 ? _f : false }, (_g = props.config.addButtonLabel) !== null && _g !== void 0 ? _g : 'Add'))),
        allowAdd && ((_h = props.config.style) === null || _h === void 0 ? void 0 : _h.variant) === 'level2' && (React.createElement(Box, null,
            React.createElement(Button, { startIcon: React.createElement(AddIcon, null), variant: 'text', onClick: () => showModal(-1), tabIndex: props.editMode ? -1 : undefined, "data-test": 'add-button', autoFocus: (_j = (!props.editMode && props.config.autoFocus)) !== null && _j !== void 0 ? _j : false }, (_k = props.config.addButtonLabel) !== null && _k !== void 0 ? _k : 'Add'))),
        allowAdd && ((_l = props.config.style) === null || _l === void 0 ? void 0 : _l.variant) === 'level3' && (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 } },
            React.createElement(Box, { sx: { flexGrow: 1, borderBottom: (theme) => '1px solid ' + theme.palette.divider } }),
            React.createElement(Button, { startIcon: React.createElement(AddIcon, null), variant: 'text', onClick: () => showModal(-1), tabIndex: props.editMode ? -1 : undefined, "data-test": 'add-button', autoFocus: (_m = (!props.editMode && props.config.autoFocus)) !== null && _m !== void 0 ? _m : false }, (_o = props.config.addButtonLabel) !== null && _o !== void 0 ? _o : 'Add'),
            React.createElement(Box, { sx: { flexGrow: 1, borderBottom: (theme) => '1px solid ' + theme.palette.divider } }))),
        error && (React.createElement(FormHelperText, { error: true, tabIndex: 0, "data-test": 'error' }, error))));
};
const WidgetFormModalPanelListEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, { title: 'Modal Panel List: ' + props.config.label }, buildGeneralTab(props, {
            key: true,
            label: true,
            autoFocus: true,
            children: [
                {
                    type: 'form.text',
                    key: 'addButtonLabel',
                    label: 'Add Button Label',
                    description: 'Default: Add',
                    emptyAsNull: true,
                },
                {
                    type: 'form.template',
                    key: 'panel.template',
                    label: 'Template',
                    props: props,
                },
                {
                    type: 'form.checkbox',
                    key: 'panelsHaveChildren',
                    label: 'Panels Have Children',
                },
            ],
            onLoad: (data) => {
                var _a;
                data.panelsHaveChildren = ((_a = data.panel) === null || _a === void 0 ? void 0 : _a.children) != null;
                return data;
            },
            onSubmit: (data) => {
                var _a, _b;
                if (data.panelsHaveChildren) {
                    if (!((_a = data.panel) === null || _a === void 0 ? void 0 : _a.children)) {
                        if (!data.panel) {
                            data.panel = {};
                        }
                        data.panel.children = [];
                    }
                }
                else {
                    if ((_b = data.panel) === null || _b === void 0 ? void 0 : _b.children) {
                        delete data.panel.children;
                    }
                }
                delete data.panelsHaveChildren;
                return data;
            },
        }), buildModalTab(props), buildAlertTab(props, { prefix: 'panel', custom: true }), buildHiddenTab(props), buildStyleTab(props, {
            children: [
                {
                    type: 'form.select',
                    key: 'style.variant',
                    label: 'Variant',
                    values: [
                        { value: 'level1', label: 'Level 1' },
                        { value: 'level2', label: 'Level 2' },
                        { value: 'level3', label: 'Level 3' },
                    ],
                    style: {
                        width: 200,
                    },
                },
            ],
        }), buildEventTab(props, { eventOnLoad: true, eventOnChange: true, autoSave: true }), buildValidateTab(props, {
            maxLength: true,
        })) }),
        React.createElement(WidgetFormModalPanelList, Object.assign({}, props))));
};
export const widgetFormModalPanelList = {
    type,
    init: (props) => {
        if (props.childDynamicRows) {
            for (const row of props.childDynamicRows) {
                if (props.config.panel.children) {
                    setModalChildSkipValidate(row.childProps.slice(props.config.panel.children.length));
                }
                else {
                    setModalChildSkipValidate(row.childProps);
                }
            }
        }
    },
    load: (props) => {
        handleWidgetOnLoad(props, props.getData());
    },
    validate: (props) => {
        var _a;
        if (isSkipValidate(props)) {
            return;
        }
        const values = props.getDataArray();
        if (props.config.validate) {
            if (props.config.validate.maxLength && values.length > props.config.validate.maxLength) {
                return ((_a = props.config.validate.maxLengthMessage) !== null && _a !== void 0 ? _a : (props.config.label ? props.config.label + ' length cannot be greater than ' : 'Length cannot be greater than ') +
                    props.config.validate.maxLength);
            }
        }
        return undefined;
    },
    update: (props) => {
        return handleWidgetUpdate(props);
    },
    getLabelValueAsTextPairs: (props, labelPrefix) => {
        return getLabelAndValuePairsFromChildDynamicRows(props, joinLabels(labelPrefix));
    },
    childConfigs: (config) => {
        if (config.panel.children) {
            return [...config.panel.children, ...config.modal.children];
        }
        else {
            return config.modal.children;
        }
    },
    childDynamicRows: true,
    component: WidgetFormModalPanelList,
    icon: React.createElement(BorderAllIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormModalPanelListEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, {
        type,
        key: 'modalPanelList',
        label: 'Modal Panel List',
        modal: { maxWidth: 'xs', fullWidth: true, children: [] },
        panel: {},
    }),
};
